module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"notifications":"Уведомления"}}')
  delete Component.options._Ctor
}
